// extracted by mini-css-extract-plugin
module.exports = {"NAME_CONTAINER_WWW_ROOT":"WwwRoot","TYPE_CONTAINER_WWW_ROOT":"Container","NAME_BECOME":"WwwRootBecome","TYPE_BECOME":"Section"};